import { useEffect } from "react";
import FormLogin from "./components/FormLogin";
import "./styles/login.css";

function Login(): JSX.Element {
  useEffect(() => {
    localStorage.clear();
  }, []);

  return <FormLogin />;
}

export default Login;